import { create } from 'zustand';
import axios from 'axios';

interface PassSubevent {
    subeventId: number;
    name: string;
    price: number;
    individualPrice: number;
    date: string;
}

interface Pass {
    passId: number;
    name: string;
    description: string;
    subevents: PassSubevent[];
    price: string;
    individualPrice: string;
}

interface PassesStore {
    eventId: number;
    passes: Pass[];
    loading: boolean;
    fetchAndSetPasses: (eventId: number, onError: (err: any) => void) => Promise<Pass[]>;
    updatePasses: (eventId: number, onError: (err: any) => void) => Promise<Pass[]>;
}

async function fetchPasses(eventId: number, onError: (err: any) => void): Promise<{ eventId: number, passes: Pass[] }> {
    try {
        const res = await axios.get(`wp-json/tts-booking/v1/events/${eventId}/passes`)
        return res.data;
    } catch (err) {
        onError(err);
        return Promise.reject();
    }
}

export const usePasses = create<PassesStore>((set, get) => ({
    eventId: -1,
    passes: [],
    loading: true,
    fetchAndSetPasses: async (eventId: number, onError: (err: any) => void) => {
        try {
            set({ loading: true });
            let response = await fetchPasses(eventId, onError);

            set({ passes: response.passes });
            set({ eventId: eventId });
            set({ loading: false });

            return Promise.resolve(response.passes);
        } catch (err) {
            console.log(err);
        }
        return Promise.reject();
    },
    updatePasses: async (eventId: number, onError: (err: any) => void) => {
        try {
            set({ loading: true });
            let response = await fetchPasses(eventId, onError);

            set({ passes: response.passes });
            set({ eventId: eventId });
            set({ loading: false });

            return Promise.resolve(response.passes);
        } catch (err) {
            console.log(err);
        }
        return Promise.reject();
    }
}));


export type { Pass, PassSubevent };
